import { getWidgetSettings } from '@wix/ambassador-innovation-widget-v2-widget-settings/http';

import { createAppAsyncThunk } from '../createAppAsyncThunk';

import { oneChatSettingsSlice } from './oneChatSettingsSlice';
import { getCurrentStatus } from './model';
import { formatImageUrl } from './utils';

export const getOneChatSettings = createAppAsyncThunk(
  'oneChatSettings/get',
  async (_, { dispatch, extra: { httpClient } }) => {
    const resp = await httpClient.request(getWidgetSettings({}));
    if (resp.status === 200) {
      dispatch(
        oneChatSettingsSlice.actions.set({
          settings: resp.data.widgetSettings ?? {},
          defaultAvatar: resp.data.defaultAvatar
            ? formatImageUrl(resp.data.defaultAvatar)
            : undefined,
          currentStatus: getCurrentStatus(resp.data.activeHandlers ?? []),
        }),
      );
    }
  },
);
